<template>
    <div class="date-picker">
        <label>Data urodzenia</label>
        <input v-model="value.day" type="text" placeholder="DD" pattern="[0-9]*" inputmode="numeric" />
        <input v-model="value.month" type="text" placeholder="MM" pattern="[0-9]*" inputmode="numeric" />
        <input v-model="value.year" type="text" placeholder="RRRR" pattern="[0-9]*" inputmode="numeric" />
    </div>
</template>

<script>
    export default {
        name: "date-picker",
        props: ['val'],
        mounted: function() {
            if(this.val) {
                this.value = this.val;
            }
        },
        data: function () {
            return {
                value: {
                    day: '',
                    month: '',
                    year: ''
                }
            }
        },
        watch: {
            "val.day": function () {
                this.value.day = this.val.day;
            },
            "val.month": function () {
                this.value.month = this.val.month;
            },
            "val.year": function () {
                this.value.year = this.val.year;
            },
            "value.day": function () {
                this.value.day = this.value.day.replace(/\D/g,'');
                this.value.day = this.value.day.substring(0, 2);

                if(this.value.day.length === 2) {
                    if (parseInt(this.value.day) > 31) {
                        this.value.day = "" + 31;
                    }

                    if (parseInt(this.value.day) < 1) {
                        this.value.day = '01';
                    }
                }

                this.$emit('input', this.value);
            },
            "value.month": function () {
                this.value.month = this.value.month.replace(/\D/g,'');
                this.value.month = this.value.month.substring(0, 2);

                if(this.value.month.length === 2) {
                    if (parseInt(this.value.month) > 12) {
                        this.value.month = "" + 12;
                    }

                    if (parseInt(this.value.month) < 1) {
                        this.value.month = '01';
                    }
                }

                this.$emit('input', this.value);
            },
            "value.year": function () {
                this.value.year = this.value.year.replace(/\D/g,'');
                this.value.year = this.value.year.substring(0, 4);

                if(this.value.year.length === 4) {
                    let year = new Date().getFullYear();

                    year = year - 4;

                    if (parseInt(this.value.year) > year) {
                        this.value.year = "" + year;
                    }

                    if (parseInt(this.value.year) < 1900) {
                        this.value.year = '1900';
                    }
                }

                this.$emit('input', this.value);
            }
        }
    }
</script>

<style scoped lang="scss">

</style>